import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access"; // Create this constant
import { HoldRestrictionGuard } from "./core/guards/hold-restriction.guard";

export const CheckoutRoute: Routes = [
  {
    path: "checkout",
    canActivate: [AuthGuard, HoldRestrictionGuard],
    data: {
      userTypes: ENROLLMENT_SHARED_USER_TYPES || [0, 1, 2, 3, 4, 5, 6, 7, 8],
      moduleId: "checkout",
    },
    //data: { userTypes: ENROLLMENT_SHARED_USER_TYPES, moduleId: "checkout" },
    loadComponent: () =>
      import("./common/components/checkout/checkout.component").then(
        (m) => m.CheckoutComponent,
      ),
    // children: [
    //   {
    //     path: "payment-status",
    //     loadComponent: () =>
    //       import("./common/components/payment-status/payment-status.component").then(
    //         (m) => m.PaymentStatusComponent,
    //       ),
    //   },
    // ],
  },
];
